<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 11:33:22
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-08 09:37:09
 * @Description: file content
-->
<template>
  <ConfigProvider :locale="locale">
    <router-view />
  </ConfigProvider>
</template>
<script lang="ts" setup>
  import { computed, watch } from 'vue'
  import { ConfigProvider } from 'ant-design-vue'

  import { useSettingStore } from '@/store'

  const sysSetting = useSettingStore()
  import { localeMap } from '@/utils/i18n/localeConfig'
  const locale = computed(() => localeMap[sysSetting.locale].antd)
</script>
<style>
  #app {
    font-family: PingFangSC, PingFangSC-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    min-width: 1200px;
  }
</style>
